<template>
    <viewer-tab ref="tab" title="Drawing" :icon="$icons.setSquare"
                v-loading="loading" :element-loading-text="loadingText"
                :url-help="$urls.HELP_DRAWING" :click-x="clickX"
                @opened="handleOpened" @active="handleTabActive">
        <div slot="header-buttons" class="header-buttons">
            <el-switch
                    style="margin-right: 15px"
                    v-model="standard"
                    inactive-text="AGMA"
                    active-text="ISO"
                    inactive-value="AGMA"
                    active-value="ISO"
                    inactive-color="var(--color)"
                    active-color="var(--color)"
                    @change="handleChangeStandard">
            </el-switch>
            <el-select
                    ref="selectPart"
                    v-model="part"
                    value-key="Id"
                    size="mini"
                    style="margin-right: 15px; margin-top: -2px;"
                    placeholder="Select a gear"
                    @change="handleChangePart"
                    clearable
                    filterable
                    no-match-text="No matching gears"
                    no-data-text="No gears in model"
                    default-first-option>
                <el-option
                        v-for="item in parts"
                        :key="item.Id"
                        :label="$handlers.model.partLabel(item)"
                        :value="item">
                </el-option>
            </el-select>
<!--            <el-button-->
<!--                    class="menu-icon-btn"-->
<!--                    type="text"-->
<!--                    @click="handleZoomFit">-->
<!--                <i class="el-icon-full-screen" title="Zoom-to-fit"/>-->
<!--            </el-button>-->
<!--            <el-button-->
<!--                    class="menu-icon-btn"-->
<!--                    type="text"-->
<!--                    @click="toggleSheet">-->
<!--                <i class="el-icon-d-caret" title="Toggle sheet"/>-->
<!--            </el-button>-->
            <el-button
                    class="menu-icon-btn"
                    type="text"
                    @click="handleManufacture">
                <i class="el-icon-location-outline" title="Find manufacturer"/>
            </el-button>
            <el-button
                    class="menu-icon-btn"
                    type="text"
                    @click="handleDownload">
                <i v-if="!downloading" class="el-icon-download" title="Download PDF"/>
                <i v-else class="el-icon-loading" title="Downloading PDF"/>
            </el-button>
        </div>
        <div id="dwg-wrapper">
            <drawing-iso-a3 ref="sheet1">
                <div v-show="gear" slot="draw" class="a3-draw-area a3-font">
                    <div class="a3-draw-area-l1">
                        <drawing-table title="Gear Data" :table="tableGeom" :symbols="!downloading"/>
                        <drawing-table title="Flank Tolerances" :table="tableFlankTolerances" :symbols="!downloading"/>
                        <drawing-table title="Radial Tolerances" :table="tableRadialTolerances" :symbols="!downloading"/>
                    </div>
                    <div class="a3-draw-area-r1">
                        <drawing-table title="Tool Data" class="w-100" :table="tableTool" :symbols="!downloading"/>
                        <div>
                            <div class="a3-transverse-teeth">
                                <div class="pixi-wrapper">
                                    <canvas ref="pixi"/>
                                </div>
                                <span class="pixi-title">Gear teeth transverse profile</span>
                            </div>
                            <div v-if="gear" class="a3-notes-and-title-block">
                                <span>NOTES:</span>
                                <ol class="a3-notes">
                                    <li>
                                        Material handling to meet the requirements of {{ materialStandard }}.
                                    </li>
                                    <li v-if="hasMaterialAgma">
                                        Material selection to meet the requirements of {{ materialData.designation }}, {{ materialData.heatTreatment }}, grade {{ materialData.grade }} per {{ materialStandard }}.
                                        Minimum surface hardness of {{ materialData.surfaceHardnessMin }} {{ materialData.surfaceHardnessScale }}.
                                        <span v-if="material.coreHardnessNumber">
                                        Minimum core hardness of {{ agmaCoreHardness() }}.
                                    </span>
                                    </li>
                                    <li v-else-if="hasMaterialIso">
                                        Material selection to meet the requirements of {{ materialData.type }} ({{ materialData.abbreviation }}) of {{ materialData.quality }} quality per {{ materialStandard }}.
                                        Minimum surface hardness of {{ isoSurfaceHardness() }}.
                                        <!--OPTIONAL SPECIFICATIONS-->
                                        <span v-if="materialData.coreHardnessMin">
                                        Minimum core hardness of {{ materialData.coreHardnessMin }} {{ materialData.coreHardnessScale }}.
                                    </span>
                                        <span v-if="material.shotPeen">
                                        Shot peen required in tooth root fillets.
                                    </span>
                                    </li>
                                    <li v-else class="text-danger">
                                        Material is unspecified for the chosen standard.
                                    </li>
                                    <li>
                                        Gear tooth flank tolerances per {{ flankQualityStandard }}, see table.
                                    </li>
                                    <li>
                                        Gear tooth radial tolerances per {{ radialQualityStandard }}, see table.
                                    </li>
                                    <li>
                                        Designer and supplier to agree on orientation of left and right flanks.
                                    </li>
                                    <li>
                                        Break all sharp edges and remove burrs.
                                    </li>
                                    <li>
                                        Gear blank web geometry is unspecified.
                                    </li>
                                    <li>
                                        Drawing generated at drivetrainhub.com.
                                    </li>
                                    <li>
                                        For quotation purposes only.
                                    </li>
                                </ol>
                                <div class="a3-title-block">
                                    <div>
                                        <span>DO NOT SCALE DRAWING</span>
                                        <span>UNLESS OTHERWISE SPECIFIED, DIMENSIONS ARE IN MILLIMETERS</span>
                                        <!--<span>BREAK ALL SHARP EDGES AND REMOVE BURRS</span>-->
                                        <span>FIRST ANGLE PROJECTION</span>
                                        <span class="d-block" style="height: 8.7mm">
                                            <img src="../../assets/img/first-angle-projection.png" style="height: 100%" alt=""/>
                                        </span>
                                    </div>
                                    <div>
                                        <table>
                                            <tr>
                                                <td/>
                                                <td>NAME</td>
                                                <td>DATE</td>
                                            </tr>
                                            <tr>
                                                <td>DRAWN</td>
                                                <td>{{ $store.getters.getUserFullName() }}</td>
                                                <td>{{ new Date().toLocaleDateString() }}</td>
                                            </tr>
                                            <tr>
                                                <td>CHECKED</td>
                                                <td/>
                                                <td/>
                                            </tr>
                                            <tr>
                                                <td>APPROVED</td>
                                                <td/>
                                                <td/>
                                            </tr>
                                        </table>
                                    </div>
                                    <div>
                                    <span class="title-block-cell">
                                        <span>TITLE</span>
                                        <span>{{ drawingTitle }}</span>
                                    </span>
                                        <span class="size-num-rev">
                                        <span class="title-block-cell br-a3">
                                            <span>SIZE</span>
                                            <span>A3</span>
                                        </span>
                                        <span class="title-block-cell br-a3">
                                            <span>DWG NO.</span>
                                            <span>{{ gear.number }}</span>
                                        </span>
                                        <span class="title-block-cell">
                                            <span>REV.</span>
                                            <span>{{ gear.version }}</span>
                                        </span>
                                    </span>
                                        <span class="scale-weight-sheet">
                                        <span class="title-block-cell br-a3">
                                            <span>SCALE</span>
                                            <span class="font-med text-center">{{ drawingScale }}</span>
                                        </span>
                                        <span class="title-block-cell br-a3">
                                            <span>WEIGHT</span>
                                            <span class="font-med text-center"/>
                                        </span>
                                        <span class="title-block-cell">
                                            <span>SHEET</span>
                                            <span class="font-med text-center font-normal-case">1 of 2</span>
                                        </span>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!gear" slot="draw" class="a3-draw-area-empty a3-font">
                    Select a gear from the dropdown
                </div>
            </drawing-iso-a3>
            <drawing-iso-a3 ref="sheet2">
                <div v-show="gear" slot="draw" class="a3-draw-area a3-font">
                    <div class="a3-draw-area-l2">
                        <drawing-table-l-r title="Profile Modifications" class="w-100" :table="tableMicroProfile" :symbols="!downloading"/>
                        <div>
                            <div class="chart-container">
                                <canvas ref="profileL"/>
                            </div>
                            <div class="chart-container">
                                <canvas ref="profileR"/>
                            </div>
                        </div>
                    </div>
                    <div class="a3-draw-area-r2">
                        <drawing-table-l-r title="Lead Modifications" class="w-100" :table="tableMicroLead" :symbols="!downloading"/>
                        <div>
                            <div class="chart-container">
                                <canvas ref="leadL"/>
                            </div>
                            <div class="chart-container">
                                <canvas ref="leadR"/>
                            </div>
                        </div>
                        <div v-if="gear" class="a3-sheet2-title-block">
                                <span class="title-block-cell">
                                    <span>DWG NO.</span>
                                    <span>{{ gear.number }}</span>
                                </span>
                            <span class="title-block-cell">
                                    <span>SIZE</span>
                                    <span class="font-med text-center">
                                        A3
                                    </span>
                                </span>
                            <span class="title-block-cell">
                                    <span>SCALE</span>
                                    <span class="font-med text-center">
                                        {{ drawingScale }}
                                    </span>
                                </span>
                            <span class="title-block-cell">
                                    <span>SHEET</span>
                                    <span class="font-med text-center font-normal-case">
                                        2 of 2
                                    </span>
                                </span>
                            <span class="title-block-cell">
                                    <span>REV.</span>
                                    <span class="font-med text-center">
                                        {{ gear.version }}
                                    </span>
                                </span>
                        </div>
                    </div>
                </div>
                <div v-show="!gear" slot="draw" class="a3-draw-area-empty a3-font">
                    Select a gear from the dropdown
                </div>
            </drawing-iso-a3>
        </div>
    </viewer-tab>
</template>

<script>
  import Chart from "chart.js";
  import { jsPDF } from "jspdf";
  import * as PIXI from "../../config/pixi";
  import ViewerTab from "../viewer/ViewerTab";
  import DrawingTable from "../_tables/DrawingTable";
  import DrawingIsoA3 from "./DrawingIsoA3";
  import DrawingTableLR from "../_tables/DrawingTableLR";
  import {copyDeepJSON, ResizeListener} from "../../assets/js/utils";
  import math from "../../assets/js/math";
  import microEqn from "../../assets/js/micro";
  import {points} from "../../assets/js/coord";
  import pixi from "../../assets/js/pixi/parts";
  import {UNITS} from "../../handlers/modules/units";
  import {getObjectById} from "../../store/helpers";
  import {apolloQuery} from "../../config/apollo";
  import gql from "graphql-tag";

  export default {
    name: "ReportDrawing",
    components: {DrawingTableLR, DrawingIsoA3, DrawingTable, ViewerTab},
    props: {
      clickX: Function,
      openId: String,
      name: String,  // unique tab name
    },
    units: {
      angle: 'deg',
      percentage: '%',
    },
    loadingText: 'Creating drawing',
    drawing: {
      width: 420,  // mm
      height: 297,  // mm
    },
    chart: {
      profile: {
        scaleLabelX: {
          display: true,
          labelString: `RELIEF ( ${UNITS.lengthSmall.toUpperCase()} )`,
        },
        scaleLabelY: {
          display: true,
          labelString: `ROLL ANGLE ( DEG )`,
        }
      },
      lead: {
        scaleLabelX: {
          display: true,
          labelString: `FACEWIDTH ( ${UNITS.length.toUpperCase()} )`,
        },
        scaleLabelY: {
          display: true,
          labelString: `RELIEF ( ${UNITS.lengthSmall.toUpperCase()} )`,
        },
      }
    },

    data() {
      return {
        // APOLLO
        parts: [],
        materialData: null,
        flankQualityData: null,
        radialQualityData: null,
        loadingText: this.$options.loadingText,
        loading: false,

        // SELECTIONS
        part: null,
        standard: 'AGMA',

        // PIXI
        pixi: null,
        pixiGear: null,
        pixiScale: 1,

        // CHARTS
        profileL: null,
        profileR: null,
        leadL: null,
        leadR: null,

        // OTHER
        resizeListener: null,
        downloading: false,
      }
    },
    computed: {
      // GEAR DATA
      gear() {
        // undefined if part undefined; copy gear object from selected part and convert units
        if (this.part) {
          const gear = copyDeepJSON(this.part.obj);
          delete gear.geom.workPieceDiameter;
          return this.$handlers.gear.convertGearGeom(gear, undefined, this.$options.units);
        }
      },
      micro() {
        // undefined if gear or micro undefined
        if (this.gear) {
          return this.$handlers.gear.convertGearMicro(this.gear, undefined, this.$options.units).micro;
        }
      },
      material() {
        // undefined if gear or material undefined
        if (this.hasMaterial) {
          return this.getStandardItem(this.gear.material.iso633652003, this.gear.material.agma2001D04);
        }
      },
      materialStandard() {
        return this.getStandardItem(this.$handlers.gear.MATERIAL_LABEL.iso633652003, this.$handlers.gear.MATERIAL_LABEL.agma2001D04);
      },
      flankQualityStandard() {
        return this.getStandardItem(this.$handlers.gear.QUALITY_LABEL.iso132812013, this.$handlers.gear.QUALITY_LABEL.agma13281B14);
      },
      radialQualityStandard() {
        return this.getStandardItem(this.$handlers.gear.QUALITY_LABEL.iso132822020, this.$handlers.gear.QUALITY_LABEL.agma20152B15);
      },
      // CONDITIONS
      hasMaterial() {
        return this.gear && this.gear.material;
      },
      hasMaterialIso() {
        // Indicates if the gear specifies an ISO material.
        return this.standard === 'ISO' && this.materialData;
      },
      hasMaterialAgma() {
        // Indicates if the gear specifies an AGMA material.
        return this.standard === 'AGMA' && this.materialData;
      },
      // TABLES
      tableGeom() {
        return !this.gear ? [] : this.$handlers.gear.tableGearGeom(this.gear, this.$options.units);
      },
      tableTool() {
        return !this.gear ? [] : this.$handlers.gear.tableGearTool(this.gear, this.$options.units)
      },
      tableFlankTolerances() {
        if (this.flankQualityData) {
          switch (this.standard) {
            case "AGMA":
              return this.$handlers.gear.tableAgma13281B14(this.flankQualityData);
            case "ISO":
            return this.$handlers.gear.tableIso132812013(this.flankQualityData);
          }
        } else {
          return [];
        }
      },
      tableRadialTolerances() {
        if (this.radialQualityData) {
          switch (this.standard) {
            case "AGMA":
              return this.$handlers.gear.tableAgma20152B15(this.radialQualityData);
            case "ISO":
              return this.$handlers.gear.tableIso132822020(this.radialQualityData);
          }
        } else {
          return [];
        }
      },
      tableMicroProfile() {
        if (!this.micro) {
          return [];
        } else {
          const [tableL, tableR] = this.$handlers.gear.tablesMicroProfile(this.gear, this.$options.units);
          return this.makeTableLR(tableL, tableR);
        }
      },
      tableMicroLead() {
        if (!this.micro) {
          return [];
        } else {
          const [tableL, tableR] = this.$handlers.gear.tablesMicroLead(this.gear, this.$options.units);
          return this.makeTableLR(tableL, tableR);
        }
      },
      // DRAWING
      drawingTitle() {
        if (this.gear) {
          return `${this.part.name} [${this.gear.name}]`;
        }
      },
      drawingScale() {
        if (this.pixiScale >= 1) {
          return `${this.pixiScale}:1`;
        } else {
          return `1:${Math.round(1 / this.pixiScale)}`;
        }
      },
    },
    apollo: {
      parts: {
        fetchPolicy: 'cache-only',
        variables() {return {Id: this.$store.state.model.doc.Id}},
        query() {return this.$store.state.model.getPartsQuery},
        update({gearsModel}) {
          return gearsModel.parts.filter(part => this.$handlers.model.isPartGearDetail(part));
        }
      },
    },

    mounted() {},
    methods: {
      // TAB
      handleOpened() {
        // initialize graphics
        this.newPixi();
        this.newCharts();

        // starter event listeners for resizing drawing
        const viewer = document.getElementById('viewer');
        this.resizeListener = new ResizeListener(viewer, this.onViewerResize);
        this.onViewerResize();

        // if specified, set drawing part
        if (this.openId) {
          this.part = getObjectById(this.parts, this.openId);
          this.handleChangePart();
        } else {
          setTimeout(this.$refs.selectPart.focus, 150);
        }
      },
      handleTabActive() {
        this.onViewerResize();
        this.resizeFitDrawing();  // required for some reason; ensures resize without overflow-x
      },

      // HELPERS
      getStandardItem(iso, agma) {
        switch (this.standard) {
          case "ISO":
            return iso;
          case "AGMA":
            return agma;
        }
      },
      makeTableLR(tableL, tableR) {
        // Combine tables to be a single array of objects containing `valueL` and `valueR` props.
        return tableL.map((item, i) => {
          const {value, ...rest} = item;
          return {
            ...rest,
            valueL: value,
            valueR: tableR[i].value,
          }
        });
      },

      // APOLLO
      async queryPropertiesIso() {
        // Query material and tolerance data per ISO, if specified for the selected gear.
        // References:
        //  1. Methods of ModelGearProps.vue.
        //  2. Call multiple queries and waiting for all to complete:
        //  https://gomakethings.com/waiting-for-multiple-all-api-responses-to-complete-with-the-vanilla-js-promise.all-method/

        // initialize
        let queryMaterial = '';
        let variables = {gearId: this.part.obj.Id};
        let args = '$gearId: ID!, ';

        // payload to query material data
        if (this.material) {
          args += '$materialId: Int!';
          variables.materialId = this.material.Id;
          queryMaterial = `
            materialIso633652003 (Id: $materialId) {
              ${this.$requests.eng.MaterialDataISO6336_5_2003}
            }`;
        }

        // batch query
        const query = {
          fetchPolicy: "cache-first",
          variables: variables,
          query: gql`query getPropertiesIso (${args}) {
            ${queryMaterial}
            gearDetail (Id: $gearId) {
                Id
                quality {
                  ${this.$requests.gear.GearQualityISO}
                }
            }
          }`,
        };
        const {data: {materialIso633652003, gearDetail: {quality}}} = await apolloQuery(query);

        // map response to local state
        this.materialData = materialIso633652003;
        this.flankQualityData = quality ? quality.iso132812013 : null;
        this.radialQualityData = quality ? quality.iso132822020 : null;
      },
      async queryPropertiesAgma() {
        // Query material and tolerance data per AGMA, if specified for the selected gear.

        // initialize
        let queryMaterial = '';
        let variables = {gearId: this.part.obj.Id};
        let args = '$gearId: ID!, ';

        // payload to query material data
        if (this.material) {
          args += '$materialId: Int!';
          variables.materialId = this.material.Id;
          queryMaterial = `
            materialAgma2001D04 (Id: $materialId) {
              ${this.$requests.eng.MaterialDataAGMA2001_D04}
            }`;
        }

        // batch query
        const query = {
          fetchPolicy: "cache-first",
          variables: variables,
          query: gql`query getPropertiesAgma (${args}) {
              ${queryMaterial}
              gearDetail (Id: $gearId) {
                Id
                quality {
                  ${this.$requests.gear.GearQualityAGMA}
                }
              }
            }`,
        };
        const {data: {materialAgma2001D04, gearDetail: {quality}}} = await apolloQuery(query);

        // map response to local state
        this.materialData = materialAgma2001D04;
        this.flankQualityData = quality ? quality.agma13281B14 : null;
        this.radialQualityData = quality ? quality.agma20152B15 : null;
      },
      async queryProperties() {
        // Query material and tolerance data for the selected standard.

        const onFinally = () => {
          window.MathJax.typeset();
          this.loading = false;
        };

        this.loading = true;
        switch (this.standard) {
          case "AGMA":
            await this.queryPropertiesAgma().finally(onFinally);
            break;
          case "ISO":
            await this.queryPropertiesIso().finally(onFinally);
            break;
        }

        // DEV ONLY
        // console.log(this.standard);
        // console.log('materialData', this.materialData);
        // console.log('flankQualityData', this.flankQualityData);
        // console.log('radialQualityData', this.radialQualityData);
        // console.log('----')
      },

      // HEADER BUTTONS
      handleManufacture() {
        this.$store.commit('TOGGLE_DIALOG_VISIBILITY', 'DialogBuildMfg');
      },
      handleDownload() {
        // Download all drawing sheets as a single PDF document.
        // References:
        //  1. Future feature to set HTML width: https://github.com/MrRio/jsPDF/issues/2925
        //  2. PDF with MathJax: https://stackoverflow.com/questions/42785850/render-mathjax-into-pdf
        //  3. MathJax issue: https://github.com/MrRio/jsPDF/issues/953
        //  4. Black canvas, modify: https://stackoverflow.com/questions/32160098/change-html-canvas-black-background-to-white-background-when-creating-jpg-image
        //  5. Black canvas, buffer limit: https://github.com/MrRio/jsPDF/issues/1418
        // FIXME {drawing} pixi canvas is usually rendered all black

        // format for download; hides symbols
        this.loadingText = 'Generating PDF';
        this.loading = true;
        this.downloading = true;
        this.resizeActualDrawing();

        // get HTML of drawing
        const drawingHtml = this.$refs.sheet1.$el.parentElement;

        // TROUBLESHOOT PIXI
        // const drawingHtml = this.$refs.sheet1.$el;
        // const drawingHtml = this.$refs.pixi.parentElement.parentElement;

        // make white background for each chart canvas
        this.whitenCanvas(this.$refs.profileL.getContext('2d'));
        this.whitenCanvas(this.$refs.profileR.getContext('2d'));
        this.whitenCanvas(this.$refs.leadL.getContext('2d'));
        this.whitenCanvas(this.$refs.leadR.getContext('2d'));

        // DEV ONLY
        // console.log('DOWNLOAD');
        // console.log(drawingHtml);
        // const exampleDiv = "<div style='width: 420mm; height: 297mm; display: grid; justify-items: center; align-items: center; background-color: #66b1ff'>FOO BAR</div>";
        // console.log('exampleDiv', exampleDiv);

        // save HTML as PDF
        new jsPDF({
          orientation: "landscape",
          format: [this.$options.drawing.height, this.$options.drawing.width],
          unit: "mm",
        }).html(drawingHtml, {
          callback: function (pdf) {
            // remove extra page due to overflow, then save
            pdf.deletePage(3).save(`${this.drawingTitle}.pdf`, {returnPromise: true})
              .finally(() => {
                // refit drawing to viewer
                this.resizeFitDrawing();
                this.downloading = false;
                this.loading = false;
                this.loadingText = this.$options.loadingText;
              });
          }.bind(this),
          html2canvas: {
            async: true,
            scale: 0.79375 / 3,  // px to mm; see references
            svgRendering: true,
            // foreignObjectRendering: true,  // causes error
          },
          image: {
            type: "jpeg",
          },
        });
      },
      whitenCanvas(ctx2d) {
        const globalCompositeOperation = ctx2d.globalCompositeOperation;
        ctx2d.globalCompositeOperation = "destination-over";
        ctx2d.fillStyle = '#FFFFFF';
        ctx2d.fillRect(0,0, ctx2d.canvas.width, ctx2d.canvas.height);
        ctx2d.globalCompositeOperation = globalCompositeOperation;
      },

      // MATERIAL
      isoSurfaceHardness() {
        // DEV: move to handlers/gear.js
        const num = this.material.surfaceHardnessNumber ? this.material.surfaceHardnessNumber : this.materialData.surfaceHardnessMin;
        return `${num} ${this.materialData.surfaceHardnessScale}`;
      },
      agmaCoreHardness() {
        // DEV: move to handlers/gear.js
        const num = this.material.coreHardnessNumber ? this.material.coreHardnessNumber : this.materialData.coreHardnessMin;
        return `${num} ${this.materialData.coreHardnessScale}`;
      },

      // DRAWING EVENTS
      async handleChangePart() {
        // Selected gear has changed, update drawing.

        // set standard based on gear material
        if (this.hasMaterial) {
          if (this.gear.material.agma2001D04) {
            this.standard = 'AGMA';
          } else if (this.gear.material.iso633652003) {
            this.standard = 'ISO';
          }
        }

        // query gear properties
        await this.queryProperties();

        // update graphics
        this.$nextTick(() => {
          this.pixi.resize();
          this.updatePixi();
          this.updateCharts();
        });
      },
      async handleChangeStandard() {
        // Selected standard, ISO or AGMA, has changed.

        // query gear properties
        await this.queryProperties();

        // refit canvas to parent
        this.$nextTick(() => {
          this.pixi.resize();
          this.updatePixi();
          this.updateCharts();
        });
      },

      // PIXI
      newPixi() {
        // WARNING: Only call if a gear has been selected, otherwise pixi canvas is not rendered.
        // NOTE: transparent is false and backgroundColor is white for the desired style in PDF.
        // NOTE: forceCanvas tried as true to avoid black image in PDF.  Did not work.
        this.pixi = new PIXI.Application({
          view: this.$refs.pixi,
          antialias: true,
          transparent: false,
          backgroundColor: 0xffffff,
          resizeTo: this.$refs.pixi.parentElement,
          // forceCanvas: true,
        });
        this.pixiGear = new PIXI.Graphics();
        this.pixiGear.rotation = -Math.PI / 2;
        this.pixi.stage.addChild(this.pixiGear);
        // this.pixiGear.cacheAsBitmap = true;  // tried to avoid black image in PDF
        // console.log('view', this.pixi.view);
      },
      scalePixi(refit=false) {
        const view = this.pixi.view;

        // scale settings
        const internal = this.$handlers.gear.isInternal(this.gear.geom);
        const depthFactor = internal ? 1.5 : 2;
        const marginTop = 75;  // tuned

        // compute whole tooth depth
        const tipRadius = Math.abs(this.gear.geom.tipDiameter / 2);
        const rootRadius = Math.abs(this.gear.geom.rootDiameter / 2);
        const wholeToothDepth = Math.abs(tipRadius - rootRadius);
        const outerRadius = internal ? rootRadius : tipRadius;

        // scale to display a factor of tooth depth
        let scale = (view.clientHeight - marginTop) / (depthFactor * wholeToothDepth);
        scale = scale >= 1 ? Math.floor(scale) : 1 / Math.ceil(1/scale);
        const x = view.clientWidth / 2;  // horizontally center
        const y = outerRadius * scale + marginTop;
        this.pixiScale = Math.abs(scale);

        // DEV ONLY - zoom-to-fit
        // const zoomDiameter = internal ? this.gear.geom.rimDiameter : this.gear.geom.tipDiameter;
        // const scale = view.clientHeight / zoomDiameter;
        // const y = view.clientHeight / 2;

        // if refitting, maintain existing sign of scale
        const gearScale = refit && this.pixiGear.scale.x < 0 ? -this.pixiScale : this.pixiScale;

        // DEV ONLY
        // console.log('view', view);
        // console.log('size', view.clientWidth, view.clientHeight);
        // console.log('gearScale', gearScale);

        // apply transformations
        this.pixiGear.position.set(x, y);
        this.pixiGear.scale.set(gearScale, gearScale);
      },
      updatePixi() {
        // Update gear graphics.

        if (this.gear) {
          this.scalePixi();
          pixi.gearGraphics(this.pixiGear, this.gear.geom, this.gear.tooth.finishedRoot, this.$options.units.angle, 7, 0xE9E9EA);
          // this.pixiGear.cacheAsBitmap = true;  // tried to avoid black image in PDF
        }
      },
      destroyPixi() {
        this.pixi.destroy(false, {children: true});
      },

      // CHARTS
      newChart(ctx, isProfile, isLeft) {
        let scaleLabelX, scaleLabelY;
        const title = isLeft ? 'LEFT FLANK' : 'RIGHT FLANK';

        if (isProfile) {
          scaleLabelX = this.$options.chart.profile.scaleLabelX;
          scaleLabelY = this.$options.chart.profile.scaleLabelY;
        } else {
          scaleLabelX = this.$options.chart.lead.scaleLabelX;
          scaleLabelY = this.$options.chart.lead.scaleLabelY;
        }

        return new Chart(ctx, {
          type: 'line',
          data: {
            datasets: [{
              fill: false,
              borderColor: 'rgb(96, 98, 102)',
              lineTension: 0.2,
              pointHitRadius: 6,
              pointRadius: 0,
            }]
          },
          options: {
            ...this.$defaults.chart.options,
            title: {
              display: true,
              text: title,
            },
            scales: {
              xAxes: [{
                type: 'linear',
                display: true,
                scaleLabel: scaleLabelX,
              }],
              yAxes: [{
                type: 'linear',
                display: true,
                scaleLabel: scaleLabelY,
              }]
            },
          },
        });
      },
      newCharts() {
        this.profileL = this.newChart(this.$refs.profileL.getContext('2d'), true, true);
        this.profileR = this.newChart(this.$refs.profileR.getContext('2d'), true, false);
        this.leadL = this.newChart(this.$refs.leadL.getContext('2d'), false, true);
        this.leadR = this.newChart(this.$refs.leadR.getContext('2d'), false, false);
      },
      updateChart(chart, pts) {
        // Update chart data for the first dataset.
        chart.data.datasets[0].data = pts;
        chart.update();
      },
      updateCharts() {
        // Update microgeometry charts.
        // NOTE: this.gear contains converted units.
        // NOTE: this.part.obj.micro contains the microgeometry data with API units.

        if (this.micro) {
          const n = 100;
          const micro = this.part.obj.micro;

          // compute relief; (-) negative sign convention
          const reliefProfileL = microEqn.profileReliefCoord(micro.profileLeft, n).map(num => -num);
          const reliefProfileR = microEqn.profileReliefCoord(micro.profileRight, n).map(num => -num);
          const reliefLeadL = microEqn.leadReliefCoord(micro.leadLeft, n).map(num => -num);
          const reliefLeadR = microEqn.leadReliefCoord(micro.leadRight, n).map(num => -num);

          // DEV ONLY
          // console.log('reliefProfileL', reliefProfileL);
          // console.log('reliefProfileR', reliefProfileR);
          // console.log('reliefLeadL', reliefLeadL);
          // console.log('reliefLeadR', reliefLeadR);

          // make arrays of profile points [{x, y}, ...]
          const {formRollAngle, tipRollAngle} = this.$handlers.eng.profileLimits(this.part.obj);
          const profileAbscissa = math.linspace(formRollAngle, tipRollAngle, n);
          const ptsProfileL = points(reliefProfileL, profileAbscissa);
          const ptsProfileR = points(reliefProfileR, profileAbscissa);

          // make arrays of lead points [{x, y}, ...]
          const xLead = math.linspace(0, this.gear.geom.facewidth, n);
          const ptsLeadL = points(xLead, reliefLeadL);
          const ptsLeadR = points(xLead, reliefLeadR);

          this.updateChart(this.profileL, ptsProfileL);
          this.updateChart(this.profileR, ptsProfileR);
          this.updateChart(this.leadL, ptsLeadL);
          this.updateChart(this.leadR, ptsLeadR);
        }
      },

      // RESIZING
      resizeFitDrawing() {
        // Zoom drawing to fit within the viewing area.
        // https://stackoverflow.com/a/46043676/5995422
        // Requires having a wrapper around sheet which has its `width` modified, plus `transform` the sheet.

        /**@type {HTMLElement}*/
        const container1 = this.$refs.sheet1.$el;
        const sheet1 = container1.firstElementChild;

        /**@type {HTMLElement}*/
        const container2 = this.$refs.sheet2.$el;
        const sheet2 = container2.firstElementChild;

        // get element to scale to
        const view = container1.parentElement;

        // DEV ONLY
        // console.log('container1', container1);
        // console.log('sheet1', sheet1);
        // console.log('container2', container2);
        // console.log('sheet2', sheet2);
        // console.log('view', view);

        // region DEPRECATED - compute scale to maintain the drawing aspect ratio
        // const parentAspectRatio = parent.clientWidth / parent.clientHeight;
        // const sheet1AspectRatio = sheet1.clientWidth / sheet1.clientHeight;
        //
        // let scale;
        // if (parentAspectRatio > sheet1AspectRatio) {
        //   // parent is proportionally wider than sheet 1; fit height
        //   scale = parent.clientHeight / sheet1.clientHeight;
        // } else {
        //   // sheet1 is proportionally wider than parent; fit width
        //   scale = parent.clientWidth / sheet1.clientWidth;
        // }
        // endregion

        // compute absolute scale to fit view width
        const mm2px = (mm) => mm * 3 / 0.79375;
        const scale = view.clientWidth / mm2px(this.$options.drawing.width + 1);  // +1 to fit without overflow

        // DEV ONLY
        // console.log('scale', scale);
        // console.log('container1.scrollWidth', container1.scrollWidth);
        // console.log('container1.style.width', container1.style.width);
        // console.log('container1 width', getComputedStyle(container1).width);
        // console.log('container1 height', getComputedStyle(container1).height);
        // console.log('-----');

        // compute scaled container size
        const containerWidth = `${this.$options.drawing.width * scale}mm`;
        const containerHeight = `${this.$options.drawing.height * scale}mm`;

        // size container #1; affects scroll height
        container1.style.width = containerWidth;
        container1.style.height = containerHeight;

        // scale sheet #1
        sheet1.style.transform = `scale(${scale})`;
        sheet1.style.transformOrigin = '0 0';
        sheet1.style.width = `calc(${containerWidth} / ${scale})`;
        sheet1.style.height = `calc(${containerHeight} / ${scale})`;

        // size container #2; affects scroll height
        container2.style.width = containerWidth;
        container2.style.height = containerHeight;
        // container2.style.overflow = 'hidden';

        // scale sheet #2
        sheet2.style.transform = `scale(${scale})`;
        sheet2.style.transformOrigin = '0 0';
        sheet2.style.width = `calc(${containerWidth} / ${scale})`;
        sheet2.style.height = `calc(${containerHeight} / ${scale})`;
      },
      resizeActualDrawing() {
        // Zoom drawing to its actual size.

        /**@type {HTMLElement}*/
        const container1 = this.$refs.sheet1.$el;
        const sheet1 = container1.firstElementChild;

        /**@type {HTMLElement}*/
        const container2 = this.$refs.sheet2.$el;
        const sheet2 = container2.firstElementChild;

        // compute scaled container size
        const containerWidth = `${this.$options.drawing.width}mm`;
        const containerHeight = `${this.$options.drawing.height}mm`;

        // size container #1; affects scroll height
        container1.style.width = containerWidth;
        container1.style.height = containerHeight;

        // scale sheet #1
        sheet1.style.transform = `revert`;
        sheet1.style.width = `revert`;
        sheet1.style.height = `revert`;

        // size container #2; affects scroll height
        container2.style.width = containerWidth;
        container2.style.height = containerHeight;

        // scale sheet #2
        sheet2.style.transform = `revert`;
        sheet2.style.width = `revert`;
        sheet2.style.height = `revert`;
      },
      resizePixiRenderer() {
        // fit renderer to parent; canvas has a default 4:3 aspect ratio without this step
        const parent = this.pixi.view.parentNode;
        this.pixi.renderer.resize(parent.clientWidth, parent.clientHeight);
      },
      onViewerResize() {
        this.resizeFitDrawing();
        this.pixi.resize();
        if (this.gear) this.scalePixi(true);

        // PLACEHOLDER {UI} desired resize behavior for pixi is difficult to achieve; there certain known issues.
        //  ~ When changing part, whichever part graphics consume the most height is what any consecutive graphics resize to.
        //  ~ Resize behavior can be "reset" by clearing the selected part, then selecting a part.
      },
    },
    beforeDestroy() {
      this.destroyPixi();

      // remove resize listener and observer
      this.resizeListener.destroy();
    }
  }
</script>

<style scoped lang="scss">
    .header-buttons {
        display: grid;
        grid-auto-flow: column;
        align-items: center;
        margin-right: 10px;
    }

    /*ISO A3 DRAWING*/
    $a3-grid-size: 10mm;
    $a3-border-width: max(0.15mm, 1px);
    $a3-border: solid black max(0.15mm, 1px);
    $a3-note-font-size: 3.50mm;
    $a3-draw-area-margin-y: $a3-grid-size/2;
    $a3-draw-area-margin-x: $a3-grid-size;
    $a3-title-block-margin: 0 (-$a3-draw-area-margin-x) (-$a3-draw-area-margin-y) 0;  /*NEGATIVE MARGINS TO HUG BORDER*/

    .mb-a3 {
        margin-bottom: $a3-grid-size;
    }
    .br-a3 {
        border-right: $a3-border;
    }

    #dwg-wrapper {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    .a3-font {
        font-size: $a3-note-font-size;
        text-transform: uppercase;
    }
    .font-normal-case {
        text-transform: none;
    }

    .a3-draw-area {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 100%;
        grid-column-gap: $a3-grid-size;
        border: $a3-border;
        overflow: hidden;

        .a3-draw-area-l1, .a3-draw-area-r1, .a3-draw-area-l2, .a3-draw-area-r2 {
            margin: $a3-draw-area-margin-y $a3-draw-area-margin-x;
            /*background-color: lightblue;*/
        }
        .a3-draw-area-l1 {
            display: grid;
            grid-template-rows: repeat(3, auto);
            grid-gap: $a3-grid-size;
            align-content: start;
        }
        .a3-draw-area-r1 {
            display: grid;
            grid-template-rows: auto 1fr;  /*CRITICAL TO RESIZE BEHAVIOR*/
            grid-row-gap: $a3-grid-size;
            /*background-color: lightpink;*/

            > div:last-of-type {
                display: grid;
                grid-template-rows: 1fr auto;
                grid-row-gap: $a3-grid-size;
            }
            .a3-transverse-teeth {
                display: grid;
                grid-template-rows: 1fr auto;

                .pixi-wrapper {
                    display: grid;  /*PREVENTS INCREMENTAL HEIGHT INCREASE ON RESIZE*/
                    justify-items: center;
                    width: 100%;
                    height: calc(100% - 2 * #{$a3-border-width});
                    border: $a3-border;
                    border-radius: 100%;
                    /*background-color: gray;*/

                    canvas {
                        max-width: 100%;  /*CRITICAL TO RESIZE BEHAVIOR*/
                        height: 100%;
                        border-radius: inherit;
                        /*background-color: lightgreen;*/
                    }
                }
                .pixi-title {
                    text-align: center;
                    margin-top: $a3-grid-size / 2;
                }
            }
            .a3-notes-and-title-block {
                align-self: end;
                justify-self: right;

                .a3-notes {}
                .a3-title-block {
                    display: grid;
                    grid-template-columns: .5fr .5fr 1fr;
                    border-top: $a3-border;
                    border-left: $a3-border;
                    font-size: .75em;
                    margin: $a3-title-block-margin;

                    /*FIRST COL*/
                    div {
                        display: grid;
                        align-items: center;
                    }
                    /*FIRST COL, ALL CELLS*/
                    div:first-child > span {
                        padding: 2pt;
                        text-align: center;
                    }
                    /*FIRST COL, FIRST CELL*/
                    div:first-child > span:first-child {
                        font-size: 1.25em;
                    }
                    /*ALL COLS EXCEPT LAST*/
                    div:not(:last-child) {
                        border-right: $a3-border;
                    }
                    /*ALL COLS, NOT LAST CELL*/
                    div > span:not(:last-child) {
                        display: block;
                        border-bottom: $a3-border;
                    }
                    /*SECOND COL OF TITLE BLOCK*/
                    div > table {
                        height: 100%;
                        border-spacing: 0;
                        border-collapse: collapse;

                        td {
                            padding: .5em;
                        }
                        td:not(:first-child) {
                            text-align: center;
                        }
                        td:not(:last-child) {
                            border-right: $a3-border;
                        }
                        tr:not(:last-child) > td {
                            border-bottom: $a3-border;
                        }
                    }

                    .size-num-rev {
                        display: grid !important;
                        grid-template-columns: auto 1fr auto;
                    }
                    .scale-weight-sheet {
                        display: grid !important;
                        grid-auto-flow: column;
                    }
                    /*SHEET CELL*/
                    .scale-weight-sheet > span:last-child {
                        cursor: pointer;
                    }
                }
            }
        }
        .a3-draw-area-l2 {
            display: grid;
            grid-template-rows: auto 1fr;
            grid-gap: $a3-grid-size;

            > div:first-of-type {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: $a3-grid-size;
                height: 150mm;
            }
        }
        .a3-draw-area-r2 {
            display: grid;
            grid-template-rows: auto 1fr auto;
            grid-gap: $a3-grid-size;

            > div:first-of-type {
                display: grid;
                grid-template-rows: 70mm 70mm;
                grid-gap: $a3-grid-size;
                height: 150mm;
            }
        }
        .chart-container {
            width: 100%;
            height: 100%;

            canvas {
                width: 100%;
                height: 100%;
                /*background-color: lightgreen;*/
            }
        }
        .a3-sheet2-title-block {
            align-self: end;
            justify-self: right;
            margin: $a3-title-block-margin;

            display: grid;
            grid-template-columns: 1fr repeat(3, minmax(auto, .3fr)) auto;
            min-width: 120mm;
            border-top: $a3-border;
            border-left: $a3-border;
            font-size: .75em;

            /*ALL COLS EXCEPT LAST*/
            > span:not(:last-child) {
                border-right: $a3-border;
            }
        }
        /*ALL CELLS*/
        .title-block-cell > span {
            display: block;
        }
        /*CELL HEADING*/
        .title-block-cell > span:first-child {
            padding: 2pt 2pt 0 2pt;
        }
        /*CELL CONTENT*/
        .title-block-cell > span:last-child {
            font-size: 1.75em;
            margin: 0 .25em;
            padding-bottom: 2pt;
        }
        .font-med {
            font-size: 1.25em !important;
        }
    }
    .a3-draw-area-empty {
        display: grid;
        justify-items: center;
        align-items: center;
        width: 100%;
        height: 100%;
        font-size: 1.25em;
    }
</style>
